export interface CourseOffering {
  [key: string]: any
  id: string
  code: string
  title: string
  academicYear: string
  term: string
  cohort: string
  startDate: string
  endDate: string
  credits: number
  instructor: string
  enrollmentCount: number
  status: "Active" | "Draft" | "Archived"
  courseType: "Lecture" | "Seminar" | "Lab" | "Project"
  assessmentCounts: {
    draft: number
    scheduled: number
    live: number
    evaluating: number
    resultsPublished: number
  }
}

export interface Assessment {
  [key: string]: any
  id: string
  code: string
  title: string
  course: string
  dueDate: string
  questionCount: number
  status: "Draft" | "Scheduled" | "Live" | "Evaluating" | "Results Published"
}

export interface Submission {
  [key: string]: any
  id: string
  studentId: string
  studentName: string
  assessmentTitle: string
  submittedAt: string
  grade: string
  score: number
  status: "In-grading" | "Graded" | ""
}

export interface StudentRecord {
  [key: string]: any
  id: string
  studentId: string
  name: string
  email: string
  phone: string
  gpa: number
  courses: string[]
  assessments: string[]
  status: "Active" | "Inactive"
  group: string
  enrollment: string
  graduation: string
  campus: string
  cohort: string
  studentCategory: string
}

export interface FacultyRecord {
  [key: string]: any
  id: string
  facultyId: string
  name: string
  email: string
  phone: string
  status: "Active" | "Inactive"
  role: "Instructor" | "Co-Instructor" | "Teaching Assistant"
  facultyType: "Faculty" | "Staff"
  adminPosition: string
  rank: string
  lastUpdated: string
  department: string
  campus: string
  category: "Full-time" | "Part-time" | "Adjunct"
  courses: string[]
  assessmentsCount: number
}

export const MOCK_COURSES: CourseOffering[] = [
  {
    id: "c1",
    code: "CS-101",
    title: "Introduction to Computer Science",
    academicYear: "2025-2026",
    term: "Summer 2026",
    cohort: "CS Cohort Alpha",
    startDate: "2026-06-01",
    endDate: "2026-08-31",
    credits: 4,
    instructor: "Dr. Alan Turing",
    enrollmentCount: 45,
    status: "Active",
    courseType: "Lecture",
    assessmentCounts: { draft: 1, scheduled: 2, live: 1, evaluating: 4, resultsPublished: 0 }
  },
  {
    id: "c2",
    code: "BIO-202",
    title: "Organic Chemistry",
    academicYear: "2025-2026",
    term: "Summer 2026",
    cohort: "Bio Pre-Med",
    startDate: "2026-06-01",
    endDate: "2026-08-31",
    credits: 4,
    instructor: "Dr. Rosalind Franklin",
    enrollmentCount: 38,
    status: "Active",
    courseType: "Lecture",
    assessmentCounts: { draft: 0, scheduled: 1, live: 1, evaluating: 6, resultsPublished: 0 }
  },
  {
    id: "c3",
    code: "MATH-301",
    title: "Linear Algebra",
    academicYear: "2025-2026",
    term: "Spring 2026",
    cohort: "Math Honors",
    startDate: "2026-01-15",
    endDate: "2026-05-15",
    credits: 3,
    instructor: "Dr. Katherine Johnson",
    enrollmentCount: 29,
    status: "Active",
    courseType: "Lecture",
    assessmentCounts: { draft: 0, scheduled: 0, live: 0, evaluating: 5, resultsPublished: 0 }
  },
  {
    id: "c4",
    code: "LIT-110",
    title: "World Literature Basics",
    academicYear: "2026-2027",
    term: "Fall 2026",
    cohort: "Humanities A",
    startDate: "2026-09-01",
    endDate: "2026-12-15",
    credits: 3,
    instructor: "Dr. Maya Angelou",
    enrollmentCount: 50,
    status: "Draft",
    courseType: "Lecture",
    assessmentCounts: { draft: 0, scheduled: 4, live: 0, evaluating: 0, resultsPublished: 0 }
  },
  {
    id: "c5",
    code: "PHY-215",
    title: "Quantum Mechanics",
    academicYear: "2025-2026",
    term: "Summer 2026",
    cohort: "Physics Majors",
    startDate: "2026-06-01",
    endDate: "2026-08-31",
    credits: 4,
    instructor: "Dr. Richard Feynman",
    enrollmentCount: 18,
    status: "Active",
    courseType: "Lecture",
    assessmentCounts: { draft: 0, scheduled: 1, live: 0, evaluating: 3, resultsPublished: 0 }
  },
  {
    id: "c6",
    code: "HIS-101",
    title: "Western Civilization",
    academicYear: "2025-2026",
    term: "Fall 2025",
    cohort: "Liberal Arts",
    startDate: "2025-09-01",
    endDate: "2025-12-15",
    credits: 3,
    instructor: "Dr. Herodotus",
    enrollmentCount: 60,
    status: "Archived",
    courseType: "Seminar",
    assessmentCounts: { draft: 0, scheduled: 0, live: 0, evaluating: 6, resultsPublished: 0 }
  },
  {
    id: "c7",
    code: "CS-201",
    title: "Data Structures & Algorithms",
    academicYear: "2025-2026",
    term: "Summer 2026",
    cohort: "CS Cohort Beta",
    startDate: "2026-06-01",
    endDate: "2026-08-31",
    credits: 4,
    instructor: "Dr. Grace Hopper",
    enrollmentCount: 40,
    status: "Active",
    courseType: "Lecture",
    assessmentCounts: { draft: 0, scheduled: 2, live: 1, evaluating: 3, resultsPublished: 0 }
  },
  {
    id: "c8",
    code: "BIO-305",
    title: "Genetics & Molecular Biology",
    academicYear: "2025-2026",
    term: "Summer 2026",
    cohort: "Pre-Med B",
    startDate: "2026-06-01",
    endDate: "2026-08-31",
    credits: 4,
    instructor: "Dr. Gregor Mendel",
    enrollmentCount: 22,
    status: "Active",
    courseType: "Lecture",
    assessmentCounts: { draft: 0, scheduled: 1, live: 1, evaluating: 3, resultsPublished: 0 }
  },
  {
    id: "c9",
    code: "MATH-102",
    title: "Calculus II",
    academicYear: "2026-2027",
    term: "Fall 2026",
    cohort: "Engineering B",
    startDate: "2026-09-01",
    endDate: "2026-12-15",
    credits: 4,
    instructor: "Dr. Isaac Newton",
    enrollmentCount: 55,
    status: "Draft",
    courseType: "Lecture",
    assessmentCounts: { draft: 0, scheduled: 3, live: 0, evaluating: 0, resultsPublished: 0 }
  },
  {
    id: "c10",
    code: "PHY-101",
    title: "General Physics I",
    academicYear: "2025-2026",
    term: "Summer 2026",
    cohort: "Pre-Med A",
    startDate: "2026-06-01",
    endDate: "2026-08-31",
    credits: 4,
    instructor: "Dr. Galileo Galilei",
    enrollmentCount: 48,
    status: "Active",
    courseType: "Lecture",
    assessmentCounts: { draft: 0, scheduled: 2, live: 1, evaluating: 4, resultsPublished: 0 }
  },
  {
    id: "c11",
    code: "ART-202",
    title: "Renaissance Art History",
    academicYear: "2025-2026",
    term: "Summer 2026",
    cohort: "Fine Arts Group",
    startDate: "2026-06-01",
    endDate: "2026-08-31",
    credits: 3,
    instructor: "Dr. Leonardo da Vinci",
    enrollmentCount: 15,
    status: "Active",
    courseType: "Lecture",
    assessmentCounts: { draft: 0, scheduled: 1, live: 0, evaluating: 2, resultsPublished: 0 }
  },
  {
    id: "c12",
    code: "CS-499",
    title: "Senior Capstone Project",
    academicYear: "2025-2026",
    term: "Summer 2026",
    cohort: "CS Seniors",
    startDate: "2026-06-01",
    endDate: "2026-08-31",
    credits: 4,
    instructor: "Dr. Ada Lovelace",
    enrollmentCount: 12,
    status: "Active",
    courseType: "Lecture",
    assessmentCounts: { draft: 0, scheduled: 0, live: 1, evaluating: 2, resultsPublished: 0 }
  },
  {
    id: "c13",
    code: "PSY-101",
    title: "Introduction to Psychology",
    academicYear: "2025-2026",
    term: "Summer 2026",
    cohort: "Social Sciences A",
    startDate: "2026-06-01",
    endDate: "2026-08-31",
    credits: 3,
    instructor: "Dr. Sigmund Freud",
    enrollmentCount: 65,
    status: "Active",
    courseType: "Lecture",
    assessmentCounts: { draft: 0, scheduled: 2, live: 0, evaluating: 7, resultsPublished: 0 }
  },
  {
    id: "c14",
    code: "CHE-301",
    title: "Physical Chemistry",
    academicYear: "2026-2027",
    term: "Fall 2026",
    cohort: "Chemistry Majors",
    startDate: "2026-09-01",
    endDate: "2026-12-15",
    credits: 4,
    instructor: "Dr. Marie Curie",
    enrollmentCount: 20,
    status: "Draft",
    courseType: "Lecture",
    assessmentCounts: { draft: 0, scheduled: 3, live: 0, evaluating: 0, resultsPublished: 0 }
  },
  {
    id: "c15",
    code: "ENG-205",
    title: "Creative Writing",
    academicYear: "2025-2026",
    term: "Spring 2026",
    cohort: "Humanities B",
    startDate: "2026-01-15",
    endDate: "2026-05-15",
    credits: 3,
    instructor: "Dr. Toni Morrison",
    enrollmentCount: 25,
    status: "Archived",
    courseType: "Seminar",
    assessmentCounts: { draft: 0, scheduled: 0, live: 0, evaluating: 4, resultsPublished: 0 }
  },
  {
    id: "c16",
    code: "ECO-101",
    title: "Macroeconomics",
    academicYear: "2025-2026",
    term: "Summer 2026",
    cohort: "Business A",
    startDate: "2026-06-01",
    endDate: "2026-08-31",
    credits: 3,
    instructor: "Dr. Adam Smith",
    enrollmentCount: 80,
    status: "Active",
    courseType: "Lecture",
    assessmentCounts: { draft: 0, scheduled: 1, live: 1, evaluating: 2, resultsPublished: 0 }
  },
  {
    id: "c17",
    code: "POL-201",
    title: "International Relations",
    academicYear: "2025-2026",
    term: "Fall 2025",
    cohort: "Pre-Law",
    startDate: "2025-09-01",
    endDate: "2025-12-15",
    credits: 3,
    instructor: "Dr. John Locke",
    enrollmentCount: 45,
    status: "Archived",
    courseType: "Seminar",
    assessmentCounts: { draft: 0, scheduled: 0, live: 0, evaluating: 3, resultsPublished: 0 }
  },
  {
    id: "c18",
    code: "SOC-101",
    title: "Introduction to Sociology",
    academicYear: "2025-2026",
    term: "Summer 2026",
    cohort: "Social Sciences B",
    startDate: "2026-06-01",
    endDate: "2026-08-31",
    credits: 3,
    instructor: "Dr. Max Weber",
    enrollmentCount: 70,
    status: "Active",
    courseType: "Lecture",
    assessmentCounts: { draft: 0, scheduled: 2, live: 0, evaluating: 2, resultsPublished: 0 }
  },
  {
    id: "c19",
    code: "PHIL-101",
    title: "Ethics and Moral Philosophy",
    academicYear: "2026-2027",
    term: "Fall 2026",
    cohort: "Liberal Arts B",
    startDate: "2026-09-01",
    endDate: "2026-12-15",
    credits: 3,
    instructor: "Dr. Immanuel Kant",
    enrollmentCount: 35,
    status: "Draft",
    courseType: "Lecture",
    assessmentCounts: { draft: 0, scheduled: 1, live: 0, evaluating: 0, resultsPublished: 0 }
  },
  {
    id: "c20",
    code: "GEO-201",
    title: "Physical Geography",
    academicYear: "2025-2026",
    term: "Spring 2026",
    cohort: "Earth Sciences",
    startDate: "2026-01-15",
    endDate: "2026-05-15",
    credits: 4,
    instructor: "Dr. Alexander von Humboldt",
    enrollmentCount: 28,
    status: "Active",
    courseType: "Lecture",
    assessmentCounts: { draft: 0, scheduled: 0, live: 0, evaluating: 5, resultsPublished: 0 }
  },
  {
    id: "c21",
    code: "MUS-101",
    title: "Music Appreciation",
    academicYear: "2025-2026",
    term: "Summer 2026",
    cohort: "Fine Arts B",
    startDate: "2026-06-01",
    endDate: "2026-08-31",
    credits: 2,
    instructor: "Dr. Wolfgang Amadeus Mozart",
    enrollmentCount: 90,
    status: "Active",
    courseType: "Lecture",
    assessmentCounts: { draft: 0, scheduled: 1, live: 1, evaluating: 3, resultsPublished: 0 }
  },
  {
    id: "c22",
    code: "CS-301",
    title: "Database Systems",
    academicYear: "2025-2026",
    term: "Summer 2026",
    cohort: "CS Cohort Alpha",
    startDate: "2026-06-01",
    endDate: "2026-08-31",
    credits: 4,
    instructor: "Dr. Edgar F. Codd",
    enrollmentCount: 38,
    status: "Active",
    courseType: "Lecture",
    assessmentCounts: { draft: 0, scheduled: 3, live: 0, evaluating: 2, resultsPublished: 0 }
  },
  {
    id: "c23",
    code: "BIO-401",
    title: "Advanced Immunology",
    academicYear: "2026-2027",
    term: "Fall 2026",
    cohort: "Pre-Med Seniors",
    startDate: "2026-09-01",
    endDate: "2026-12-15",
    credits: 4,
    instructor: "Dr. Edward Jenner",
    enrollmentCount: 15,
    status: "Draft",
    courseType: "Lecture",
    assessmentCounts: { draft: 0, scheduled: 2, live: 0, evaluating: 0, resultsPublished: 0 }
  },
  {
    id: "c24",
    code: "MATH-401",
    title: "Topology",
    academicYear: "2025-2026",
    term: "Spring 2026",
    cohort: "Math Seniors",
    startDate: "2026-01-15",
    endDate: "2026-05-15",
    credits: 3,
    instructor: "Dr. Leonhard Euler",
    enrollmentCount: 10,
    status: "Archived",
    courseType: "Seminar",
    assessmentCounts: { draft: 0, scheduled: 0, live: 0, evaluating: 4, resultsPublished: 0 }
  },
  {
    id: "c25",
    code: "LIT-301",
    title: "Shakespearean Tragedies",
    academicYear: "2025-2026",
    term: "Summer 2026",
    cohort: "English Majors",
    startDate: "2026-06-01",
    endDate: "2026-08-31",
    credits: 3,
    instructor: "Dr. William Shakespeare",
    enrollmentCount: 30,
    status: "Active",
    courseType: "Lecture",
    assessmentCounts: { draft: 0, scheduled: 1, live: 0, evaluating: 3, resultsPublished: 0 }
  }
]

export const MOCK_ASSESSMENTS: Assessment[] = [
  { id: "a1", code: "ASM-101", title: "CS-101 Midterm Exam", course: "CS-101", dueDate: "2026-10-15", questionCount: 25, status: "Evaluating" },
  { id: "a2", code: "ASM-102", title: "BIO-202 Organic Synthesis Quiz", course: "BIO-202", dueDate: "2026-09-22", questionCount: 15, status: "Evaluating" },
  { id: "a3", code: "ASM-103", title: "MATH-301 Vector Spaces Homework", course: "MATH-301", dueDate: "2026-10-01", questionCount: 10, status: "Scheduled" },
  { id: "a4", code: "ASM-104", title: "CS-201 Final Practical Exam", course: "CS-201", dueDate: "2026-12-10", questionCount: 50, status: "Draft" },
  { id: "a5", code: "ASM-105", title: "BIO-305 Genetic Mapping Test", course: "BIO-305", dueDate: "2026-11-05", questionCount: 20, status: "Scheduled" },
  { id: "a6", code: "ASM-106", title: "PHY-215 Schrödinger Equation Quiz", course: "PHY-215", dueDate: "2026-10-20", questionCount: 12, status: "Live" },
  { id: "a7", code: "ASM-107", title: "LIT-110 Prose Analysis Essay", course: "LIT-110", dueDate: "2027-02-14", questionCount: 5, status: "Draft" },
  { id: "a8", code: "ASM-108", title: "ART-202 Sistine Chapel Analysis", course: "ART-202", dueDate: "2026-10-30", questionCount: 8, status: "Scheduled" },
  { id: "a9", code: "ASM-109", title: "CS-101 Final Exam Preview", course: "CS-101", dueDate: "2026-12-15", questionCount: 15, status: "Draft" },
  { id: "a10", code: "ASM-110", title: "BIO-202 Stereochemistry Midterm", course: "BIO-202", dueDate: "2026-10-10", questionCount: 30, status: "Evaluating" },
  { id: "a11", code: "ASM-111", title: "MATH-102 Infinite Series Quiz", course: "MATH-102", dueDate: "2027-03-01", questionCount: 15, status: "Draft" },
  { id: "a12", code: "ASM-112", title: "PHY-101 Kinematics Test", course: "PHY-101", dueDate: "2026-09-30", questionCount: 20, status: "Results Published" }
]

/** Course-offering assessment slugs → lifecycle (matches offering detail templates). */
const OFFERING_ASSESSMENT_STATUS: Record<string, Assessment["status"]> = {
  a1: "Evaluating",
  a2: "Results Published",
  a3: "Evaluating",
  a4: "Live",
  a5: "Draft",
  a6: "Scheduled",
  a7: "Draft",
}

/** Resolve lifecycle status from hub id, code, or course-offering slug (`CS101-a2`). */
export function resolveAssessmentLifecycleStatus(
  assessmentId: string | undefined,
): Assessment["status"] | undefined {
  if (!assessmentId) return undefined
  const offeringMatch = assessmentId.match(/-a(\d+)$/)
  if (offeringMatch) {
    const offeringSlug = `a${offeringMatch[1]}`
    if (offeringSlug in OFFERING_ASSESSMENT_STATUS) {
      return OFFERING_ASSESSMENT_STATUS[offeringSlug]
    }
  }
  const hub = MOCK_ASSESSMENTS.find(
    (row) => row.id === assessmentId || row.code === assessmentId,
  )
  return hub?.status
}

const DUMMY_ASSESSMENT_NAMES = [
  "Midterm Exam",
  "Pop Quiz 1",
  "Lab Practical",
  "Final Examination",
  "Research Paper Draft",
  "Make-up Exam",
  "Extra Credit Quiz",
]

export function resolveAssessmentTitle(assessmentId?: string): string {
  return resolveAssessmentContext(assessmentId).title
}

export type ResolvedAssessmentContext = {
  id: string
  title: string
  courseCode: string
}

/** Same lookup chain as assessment-details (mock record → composite id → fallback). */
export function resolveAssessmentContext(
  assessmentId?: string,
): ResolvedAssessmentContext {
  const found = MOCK_ASSESSMENTS.find(
    (a) => a.id === assessmentId || a.code === assessmentId,
  )
  if (found) {
    return { id: found.id, title: found.title, courseCode: found.course }
  }

  if (assessmentId && assessmentId.includes("-a")) {
    const parts = assessmentId.split("-a")
    const courseCode = parts[0]
    const idx = parseInt(parts[1], 10) - 1
    const name = DUMMY_ASSESSMENT_NAMES[idx] || DUMMY_ASSESSMENT_NAMES[0]
    return {
      id: assessmentId,
      title: `${courseCode} ${name}`,
      courseCode,
    }
  }

  const fallback = MOCK_ASSESSMENTS[0]
  return {
    id: fallback?.id ?? "a1",
    title: fallback?.title ?? "Assessment",
    courseCode: fallback?.course ?? "CS-101",
  }
}

export function resolveCourseForAssessment(
  courseCode: string,
): CourseOffering | null {
  const normalized = courseCode.toLowerCase()
  return (
    MOCK_COURSES.find(
      (c) =>
        c.code.toLowerCase() === normalized ||
        c.id.toLowerCase() === normalized,
    ) ?? null
  )
}

export type ExamManagementBreadcrumb = {
  label: string
  href?: string
}

/** Course-offering trail shared by assessment and submission detail pages. */
export function buildCourseAssessmentBreadcrumbs(
  assessmentId: string,
  options?: { linkAssessment?: boolean },
): ExamManagementBreadcrumb[] {
  const assessment = resolveAssessmentContext(assessmentId)
  const course = resolveCourseForAssessment(assessment.courseCode)
  const items: ExamManagementBreadcrumb[] = [
    { label: "Exam Management" },
    { label: "Course Offerings", href: "/exam-management/course-offerings" },
  ]

  if (course) {
    items.push({
      label: `${course.code} · ${course.title}`,
      href: `/exam-management/course-offerings/${course.id}`,
    })
  }

  if (options?.linkAssessment) {
    items.push({
      label: assessment.title,
      href: course
        ? `/exam-management/course-offerings/${course.id}/assessments/${assessment.id}`
        : `/exam-management/assessments/${assessment.id}`,
    })
  }

  return items
}

export function adjustSubmissionByAssessmentStatus(submission: Submission, assessmentStatus?: string): Submission {
  const assessment = MOCK_ASSESSMENTS.find(
    a => a.title.toLowerCase() === submission.assessmentTitle.toLowerCase()
  );
  
  const status = assessmentStatus || assessment?.status;
  if (!status) return submission;

  const normStatus = status.toLowerCase();
  const updated = { ...submission };

  if (normStatus === "results published") {
    updated.status = "Graded";
    if (updated.grade === "Pending" || !updated.grade) {
      updated.grade = "B";
      updated.score = 85;
    }
    if (!updated.submittedAt) {
      const dateVal = assessment?.dueDate || "2026-06-18";
      updated.submittedAt = `${dateVal} 14:30`;
    }
  } else if (normStatus === "evaluating") {
    if (!updated.submittedAt) {
      const dateVal = assessment?.dueDate || "2026-06-18";
      updated.submittedAt = `${dateVal} 14:30`;
    }
    if (updated.status === "Graded") {
      if (updated.grade === "Pending" || !updated.grade) {
        updated.grade = "B";
        updated.score = 85;
      }
    } else {
      updated.status = "In-grading";
      updated.grade = "Pending";
      updated.score = 0;
    }
  } else if (normStatus === "scheduled" || normStatus === "draft" || normStatus === "live") {
    updated.submittedAt = "";
    updated.status = "";
    updated.grade = "";
    updated.score = 0;
  }

  return updated;
}

const STATIC_MOCK_SUBMISSIONS: Submission[] = [
  { id: "s1", studentId: "STU-001", studentName: "John Doe", assessmentTitle: "CS-101 Midterm Exam", submittedAt: "2026-10-14 14:32", grade: "A", score: 92, status: "Graded" },
  { id: "s2", studentId: "STU-002", studentName: "Jane Smith", assessmentTitle: "CS-101 Midterm Exam", submittedAt: "2026-10-15 08:11", grade: "B", score: 85, status: "Graded" },
  { id: "s3", studentId: "STU-003", studentName: "Alice Johnson", assessmentTitle: "BIO-202 Stereochemistry Midterm", submittedAt: "2026-10-09 23:45", grade: "Pending", score: 0, status: "In-grading" },
  { id: "s4", studentId: "STU-004", studentName: "Bob Brown", assessmentTitle: "CS-101 Midterm Exam", submittedAt: "2026-10-15 11:59", grade: "C", score: 74, status: "Graded" },
  { id: "s5", studentId: "STU-001", studentName: "John Doe", assessmentTitle: "BIO-202 Stereochemistry Midterm", submittedAt: "2026-10-10 09:15", grade: "Pending", score: 0, status: "In-grading" },
  { id: "s6", studentId: "STU-002", studentName: "Jane Smith", assessmentTitle: "MATH-301 Vector Spaces Homework", submittedAt: "2026-09-30 18:22", grade: "A+", score: 98, status: "Graded" },
  { id: "s7", studentId: "STU-005", studentName: "Charlie Green", assessmentTitle: "PHY-215 Schrödinger Equation Quiz", submittedAt: "2026-10-19 16:04", grade: "A-", score: 90, status: "Graded" },
  { id: "s8", studentId: "STU-006", studentName: "Diana Prince", assessmentTitle: "ART-202 Sistine Chapel Analysis", submittedAt: "2026-10-29 12:00", grade: "Pending", score: 0, status: "In-grading" },
  { id: "s9", studentId: "STU-003", studentName: "Alice Johnson", assessmentTitle: "MATH-301 Vector Spaces Homework", submittedAt: "2026-10-01 01:10", grade: "B-", score: 81, status: "Graded" },
  { id: "s10", studentId: "STU-007", studentName: "Evan Wright", assessmentTitle: "CS-101 Midterm Exam", submittedAt: "2026-10-15 11:30", grade: "F", score: 55, status: "Graded" },
  { id: "s11", studentId: "STU-008", studentName: "Fiona Gallagher", assessmentTitle: "PHY-101 Kinematics Test", submittedAt: "2026-09-29 10:20", grade: "B+", score: 88, status: "Graded" },
  { id: "s12", studentId: "STU-009", studentName: "George Bluth", assessmentTitle: "BIO-202 Organic Synthesis Quiz", submittedAt: "2026-09-21 15:45", grade: "C+", score: 78, status: "Graded" },
  { id: "s13", studentId: "STU-001", studentName: "John Doe", assessmentTitle: "PHY-101 Kinematics Test", submittedAt: "2026-09-29 11:05", grade: "B+", score: 88, status: "Graded" },
]

export const MOCK_SUBMISSIONS: Submission[] = STATIC_MOCK_SUBMISSIONS.map(s => adjustSubmissionByAssessmentStatus(s));

export const MOCK_STUDENTS: StudentRecord[] = [
  { id: "st1", studentId: "STU-001", name: "John Doe", email: "john.doe@university.edu", phone: "555-0101", gpa: 3.65, courses: ["CS-101", "BIO-202", "CS-201"], assessments: ["ASM-101", "ASM-110", "ASM-109"], status: "Active", group: "Group A", enrollment: "Fall 2024", graduation: "Spring 2028", campus: "Main Campus", cohort: "CS Cohort Alpha", studentCategory: "Undergraduate" },
  { id: "st2", studentId: "STU-002", name: "Jane Smith", email: "jane.smith@university.edu", phone: "555-0102", gpa: 3.89, courses: ["CS-101", "BIO-202", "MATH-301"], assessments: ["ASM-101", "ASM-102", "ASM-103"], status: "Active", group: "Group B", enrollment: "Fall 2024", graduation: "Spring 2028", campus: "Main Campus", cohort: "Bio Pre-Med", studentCategory: "Undergraduate" },
  { id: "st3", studentId: "STU-003", name: "Alice Johnson", email: "alice.j@university.edu", phone: "555-0103", gpa: 3.42, courses: ["BIO-202", "MATH-301", "PHY-101"], assessments: ["ASM-102", "ASM-103", "ASM-112"], status: "Active", group: "Group A", enrollment: "Spring 2025", graduation: "Fall 2028", campus: "North Campus", cohort: "Math Honors", studentCategory: "Undergraduate" },
  { id: "st4", studentId: "STU-004", name: "Bob Brown", email: "bob.brown@university.edu", phone: "555-0104", gpa: 2.98, courses: ["CS-101", "CS-201", "PHY-101"], assessments: ["ASM-101", "ASM-104", "ASM-112"], status: "Active", group: "Group C", enrollment: "Fall 2023", graduation: "Spring 2027", campus: "Main Campus", cohort: "CS Cohort Alpha", studentCategory: "Undergraduate" },
  { id: "st5", studentId: "STU-005", name: "Charlie Green", email: "c.green@university.edu", phone: "555-0105", gpa: 3.55, courses: ["PHY-215", "CS-201", "MATH-301"], assessments: ["ASM-106", "ASM-104", "ASM-103"], status: "Active", group: "Group B", enrollment: "Fall 2025", graduation: "Spring 2029", campus: "East Campus", cohort: "Physics Majors", studentCategory: "Undergraduate" },
  { id: "st6", studentId: "STU-006", name: "Diana Prince", email: "diana.p@university.edu", phone: "555-0106", gpa: 4.00, courses: ["ART-202", "LIT-110"], assessments: ["ASM-108", "ASM-107"], status: "Active", group: "Group A", enrollment: "Fall 2023", graduation: "Spring 2027", campus: "Main Campus", cohort: "Fine Arts Group", studentCategory: "Undergraduate" },
  { id: "st7", studentId: "STU-007", name: "Evan Wright", email: "evan.w@university.edu", phone: "555-0107", gpa: 2.12, courses: ["CS-101", "MATH-102"], assessments: ["ASM-101", "ASM-111"], status: "Active", group: "Group D", enrollment: "Fall 2024", graduation: "Spring 2028", campus: "North Campus", cohort: "Engineering B", studentCategory: "Undergraduate" },
  { id: "st8", studentId: "STU-008", name: "Fiona Gallagher", email: "fiona.g@university.edu", phone: "555-0108", gpa: 3.01, courses: ["PHY-101", "LIT-110"], assessments: ["ASM-112", "ASM-107"], status: "Active", group: "Group B", enrollment: "Spring 2024", graduation: "Fall 2027", campus: "Main Campus", cohort: "Pre-Med A", studentCategory: "Undergraduate" },
  { id: "st9", studentId: "STU-009", name: "George Bluth", email: "gbluth@university.edu", phone: "555-0109", gpa: 2.75, courses: ["BIO-202", "ART-202"], assessments: ["ASM-102", "ASM-108"], status: "Inactive", group: "Group C", enrollment: "Fall 2022", graduation: "Spring 2026", campus: "East Campus", cohort: "Bio Pre-Med", studentCategory: "Undergraduate" },
  { id: "st10", studentId: "STU-010", name: "Hannah Abbott", email: "habbott@university.edu", phone: "555-0110", gpa: 3.33, courses: ["CS-201", "MATH-301"], assessments: ["ASM-104", "ASM-103"], status: "Active", group: "Group A", enrollment: "Fall 2024", graduation: "Spring 2028", campus: "Main Campus", cohort: "CS Cohort Beta", studentCategory: "Undergraduate" },
  { id: "st11", studentId: "STU-011", name: "Ian Malcolm", email: "imalcolm@university.edu", phone: "555-0111", gpa: 3.91, courses: ["PHY-215", "MATH-301"], assessments: ["ASM-106", "ASM-103"], status: "Active", group: "Group D", enrollment: "Fall 2023", graduation: "Spring 2027", campus: "North Campus", cohort: "Physics Majors", studentCategory: "Undergraduate" },
  { id: "st12", studentId: "STU-012", name: "Julia Roberts", email: "jroberts@university.edu", phone: "555-0112", gpa: 3.47, courses: ["LIT-110", "ART-202"], assessments: ["ASM-107", "ASM-108"], status: "Active", group: "Group B", enrollment: "Spring 2025", graduation: "Fall 2028", campus: "Main Campus", cohort: "Humanities A", studentCategory: "Undergraduate" },
  { id: "st13", studentId: "STU-013", name: "Kevin Mitnick", email: "kmitnick@university.edu", phone: "555-0113", gpa: 3.20, courses: ["HIS-101", "BIO-305", "CS-499", "POL-201", "GEO-201", "CS-301"], assessments: [], status: "Active", group: "Group A", enrollment: "Fall 2024", graduation: "Spring 2028", campus: "Main Campus", cohort: "Cybersecurity", studentCategory: "Undergraduate" },
  { id: "st14", studentId: "STU-014", name: "Linus Torvalds", email: "ltorvalds@university.edu", phone: "555-0114", gpa: 3.95, courses: ["HIS-101", "BIO-305", "PSY-101", "SOC-101", "MUS-101", "BIO-401"], assessments: [], status: "Active", group: "Group B", enrollment: "Fall 2024", graduation: "Spring 2028", campus: "Main Campus", cohort: "Systems Eng", studentCategory: "Undergraduate" },
  { id: "st15", studentId: "STU-015", name: "Tim Berners-Lee", email: "timbl@university.edu", phone: "555-0115", gpa: 3.75, courses: ["HIS-101", "CS-499", "CHE-301", "PHIL-101", "CS-301", "MATH-401"], assessments: [], status: "Active", group: "Group C", enrollment: "Spring 2025", graduation: "Fall 2028", campus: "North Campus", cohort: "Web Tech", studentCategory: "Undergraduate" },
  { id: "st16", studentId: "STU-016", name: "Vint Cerf", email: "vcerf@university.edu", phone: "555-0116", gpa: 3.82, courses: ["BIO-305", "PSY-101", "ENG-205", "PHIL-101", "BIO-401", "LIT-301"], assessments: [], status: "Active", group: "Group D", enrollment: "Fall 2023", graduation: "Spring 2027", campus: "Main Campus", cohort: "Networking", studentCategory: "Undergraduate" },
  { id: "st17", studentId: "STU-017", name: "Donald Knuth", email: "dknuth@university.edu", phone: "555-0117", gpa: 4.00, courses: ["CS-499", "CHE-301", "ECO-101", "GEO-201", "CS-301", "MATH-401"], assessments: [], status: "Active", group: "Group A", enrollment: "Fall 2023", graduation: "Spring 2027", campus: "Main Campus", cohort: "Algorithms", studentCategory: "Undergraduate" },
  { id: "st18", studentId: "STU-018", name: "Alan Kay", email: "akay@university.edu", phone: "555-0118", gpa: 3.90, courses: ["PSY-101", "ENG-205", "POL-201", "GEO-201", "BIO-401", "LIT-301"], assessments: [], status: "Active", group: "Group B", enrollment: "Spring 2024", graduation: "Fall 2027", campus: "Main Campus", cohort: "Smalltalk", studentCategory: "Undergraduate" },
  { id: "st19", studentId: "STU-019", name: "Grace Hopper", email: "ghopper@university.edu", phone: "555-0119", gpa: 3.88, courses: ["CHE-301", "ECO-101", "POL-201", "SOC-101", "MUS-101", "MATH-401"], assessments: [], status: "Active", group: "Group C", enrollment: "Fall 2024", graduation: "Spring 2028", campus: "East Campus", cohort: "Compilers", studentCategory: "Undergraduate" },
  { id: "st20", studentId: "STU-020", name: "Steve Wozniak", email: "swoz@university.edu", phone: "555-0120", gpa: 3.60, courses: ["ENG-205", "ECO-101", "SOC-101", "PHIL-101", "MUS-101", "LIT-301"], assessments: [], status: "Active", group: "Group D", enrollment: "Fall 2024", graduation: "Spring 2028", campus: "West Campus", cohort: "Hardware", studentCategory: "Undergraduate" }
]

export const MOCK_FACULTY: FacultyRecord[] = [
  { id: "f1", facultyId: "FAC-001", name: "Dr. Alan Turing", email: "a.turing@university.edu", phone: "555-0201", status: "Active", role: "Instructor", facultyType: "Faculty", adminPosition: "Department Chair", rank: "Professor", lastUpdated: "2026-06-15", department: "Computer Science", campus: "Main Campus", category: "Full-time", courses: ["CS-101", "CS-201"], assessmentsCount: 5 },
  { id: "f2", facultyId: "FAC-002", name: "Dr. Rosalind Franklin", email: "r.franklin@university.edu", phone: "555-0202", status: "Active", role: "Instructor", facultyType: "Faculty", adminPosition: "None", rank: "Associate Professor", lastUpdated: "2026-06-12", department: "Biology", campus: "Main Campus", category: "Full-time", courses: ["BIO-202", "BIO-305"], assessmentsCount: 6 },
  { id: "f3", facultyId: "FAC-003", name: "Dr. Katherine Johnson", email: "k.johnson@university.edu", phone: "555-0203", status: "Active", role: "Instructor", facultyType: "Faculty", adminPosition: "None", rank: "Professor", lastUpdated: "2026-06-14", department: "Mathematics", campus: "Main Campus", category: "Full-time", courses: ["MATH-301", "MATH-102"], assessmentsCount: 5 },
  { id: "f4", facultyId: "FAC-004", name: "Dr. Richard Feynman", email: "r.feynman@university.edu", phone: "555-0204", status: "Active", role: "Instructor", facultyType: "Faculty", adminPosition: "Director of Physics Lab", rank: "Professor", lastUpdated: "2026-06-11", department: "Physics", campus: "Main Campus", category: "Full-time", courses: ["PHY-215", "PHY-101"], assessmentsCount: 4 },
  { id: "f5", facultyId: "FAC-005", name: "Dr. Maya Angelou", email: "m.angelou@university.edu", phone: "555-0205", status: "Active", role: "Instructor", facultyType: "Faculty", adminPosition: "None", rank: "Professor", lastUpdated: "2026-06-10", department: "Literature", campus: "Main Campus", category: "Full-time", courses: ["LIT-110"], assessmentsCount: 2 },
  { id: "f6", facultyId: "FAC-006", name: "Dr. Gregor Mendel", email: "g.mendel@university.edu", phone: "555-0206", status: "Active", role: "Co-Instructor", facultyType: "Faculty", adminPosition: "None", rank: "Associate Professor", lastUpdated: "2026-06-09", department: "Biology", campus: "Main Campus", category: "Adjunct", courses: ["BIO-305"], assessmentsCount: 3 },
  { id: "f7", facultyId: "FAC-007", name: "Dr. Grace Hopper", email: "g.hopper@university.edu", phone: "555-0207", status: "Active", role: "Co-Instructor", facultyType: "Faculty", adminPosition: "None", rank: "Professor", lastUpdated: "2026-06-08", department: "Computer Science", campus: "Main Campus", category: "Full-time", courses: ["CS-201", "CS-101"], assessmentsCount: 4 },
  { id: "f8", facultyId: "FAC-008", name: "Dr. Isaac Newton", email: "i.newton@university.edu", phone: "555-0208", status: "Active", role: "Instructor", facultyType: "Faculty", adminPosition: "None", rank: "Professor", lastUpdated: "2026-06-07", department: "Mathematics", campus: "Main Campus", category: "Full-time", courses: ["MATH-102"], assessmentsCount: 2 },
  { id: "f9", facultyId: "FAC-009", name: "Dr. Galileo Galilei", email: "g.galilei@university.edu", phone: "555-0209", status: "Active", role: "Instructor", facultyType: "Faculty", adminPosition: "None", rank: "Professor", lastUpdated: "2026-06-06", department: "Physics", campus: "Main Campus", category: "Full-time", courses: ["PHY-101"], assessmentsCount: 3 },
  { id: "f10", facultyId: "FAC-010", name: "Dr. Leonardo da Vinci", email: "l.vinci@university.edu", phone: "555-0210", status: "Active", role: "Instructor", facultyType: "Faculty", adminPosition: "None", rank: "Professor", lastUpdated: "2026-06-05", department: "Fine Arts", campus: "Main Campus", category: "Full-time", courses: ["ART-202"], assessmentsCount: 2 },
  { id: "f11", facultyId: "FAC-011", name: "Dr. Ada Lovelace", email: "a.lovelace@university.edu", phone: "555-0211", status: "Active", role: "Instructor", facultyType: "Faculty", adminPosition: "None", rank: "Professor", lastUpdated: "2026-06-04", department: "Computer Science", campus: "Main Campus", category: "Full-time", courses: ["CS-499"], assessmentsCount: 2 },
  { id: "f12", facultyId: "FAC-012", name: "Dr. Albert Einstein", email: "a.einstein@university.edu", phone: "555-0212", status: "Inactive", role: "Instructor", facultyType: "Faculty", adminPosition: "None", rank: "Professor", lastUpdated: "2026-05-30", department: "Physics", campus: "Main Campus", category: "Full-time", courses: [], assessmentsCount: 0 },
  { id: "f13", facultyId: "FAC-013", name: "Margaret Hamilton", email: "m.hamilton@university.edu", phone: "555-0213", status: "Active", role: "Teaching Assistant", facultyType: "Staff", adminPosition: "Lead Lab Coordinator", rank: "Lecturer", lastUpdated: "2026-06-13", department: "Computer Science", campus: "Main Campus", category: "Full-time", courses: ["CS-101", "CS-201"], assessmentsCount: 4 }
]
